import { render, staticRenderFns } from "./Kostenstruktur.vue?vue&type=template&id=51baf8b8&scoped=true&"
import script from "./Kostenstruktur.vue?vue&type=script&lang=ts&"
export * from "./Kostenstruktur.vue?vue&type=script&lang=ts&"
import style0 from "./Kostenstruktur.vue?vue&type=style&index=0&id=51baf8b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51baf8b8",
  null
  
)

export default component.exports